import styled from "styled-components";

export const Main = styled.main`
  padding-left: 1rem;
`;

export const LoadSection = styled.section`

  position: absolute;
  top: 50%;
  left: calc(50% + 4rem);
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  align-items: center;

  user-select: none;

  > img {
    width: 4rem;
    height: 4rem;
  }

  > p {
    margin-top: 1rem;
    font-size: 14px;
    color: var(--gray-contentoh);
  }

`;

export const MassiveProductList = styled.section`

  height: calc(100vh - 10rem);

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 2rem;
  padding: 1rem 0;

  list-style: none;

  overflow-y: auto;

`;